<template>
  <label class="flex justify-center">
    <input
      class="hidden"
      type="checkbox"
      v-model="checked"
      @click="$emit('click', $event)"
    >
    <div class="toggle-path w-12 h-6 rounded-full border border-white border-solid">
      <div class="toggle-circle w-4 h-4 bg-white m-1 rounded-full" />
    </div>
  </label>
</template>

<script>
  export default {
    props: {
      checked: { type: Boolean, required: true },
    }
  }
</script>

<style>
  .toggle-path {
    transition: all 0.2s ease-in-out;
  }
  .toggle-circle {
    transition: all 0.2s ease-in-out;
  }
  input:checked ~ .toggle-path .toggle-circle {
    transform: translateX(1.5rem);
  }
  input:checked ~ .toggle-path {
    background-color: #f59100;
  }
</style>
